import { useCallback, useState } from 'react';
import jwtDecode from 'jwt-decode';

import { getAccessToken } from '@/utils/auth/token.utils';
import { EnvUtils } from '@/utils/env.utils';

export function useGetCurrentUserId() {
  const [currentUserId, setCurrentUserId] = useState<string | null>(null);

  const getCurrentUserId = useCallback(async () => {
    if (EnvUtils.isDevelopment()) {
      const userId = process.env.ACCESS_TOKEN_DEV_USER_ID ?? null;
      setCurrentUserId(userId);
      return userId;
    }

    const token = await getAccessToken();
    const decoded = jwtDecode<{ acid: string }>(token);
    const userId = decoded?.acid ?? null;
    setCurrentUserId(userId);
    return userId;
  }, []);

  return {
    getCurrentUserId,
    currentUserId,
  } as const;
}
